import { Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { ClaimService } from 'src/app/core/services/claim.service';
import { NotificationService } from 'src/app/core/services/shared-services/notification.service';
import { ButtonText, Messages, MessageType, ModalCssClass, UiClaimStatus } from '../../app.constants';
import { ProductService } from 'src/app/core/services/product.service';
import { OrcaPassportCancelRequestDTO, OrcaPassportFerryRequestDTO } from 'src/app/core/models/product';
import { AppUtils } from 'src/app/core/app-utils';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { OrcaFerryStatus } from '../../app.enums';
import { Subscription } from 'rxjs';
import { ShoppingCartService } from 'src/app/core/services/shopping-cart.service';
import { CartDetailDTO, DeleteCartProductDTO } from 'src/app/core/models/shopping-cart';

@Component({
  selector: 'eb-warning-modal',
  templateUrl: './warning-modal.component.html',
})
export class WarningModalComponent implements OnInit, OnDestroy {
  @ViewChild('errorContainer', { static: true, read: ViewContainerRef }) errorContainer: ViewContainerRef;
  title!: string;
  message!: string;
  footerNote!: string;
  isHTML = false;
  showActionButton = false;
  showCancelButton = false;
  btnText!: string;
  cancelText!: string;
  imageSrc!: string;
  componentData: any;
  componentName!: string;
  idClaim: number;
  idClaimType: number;
  idMemberSmartCardOrca: number;
  accountNumber = '';
  mbbShoppingCartDetails: CartDetailDTO;
  modalRefFerrySuccess: MdbModalRef<ConfirmModalComponent>;
  productSubscription: Subscription;
  shoppingCartSubscription: Subscription;
  deleteBikePurchaseClaimSubscription: Subscription;

  constructor(
    public modalRef: MdbModalRef<WarningModalComponent>,
    private claimService: ClaimService,
    private notificationService: NotificationService,
    private productService: ProductService,
    private shoppingCartService: ShoppingCartService
  ) { }
  ngOnInit(): void {
    this.idClaim = this.componentData?.idClaim;
    if (this.componentData?.issueType == 'Parking') {
      this.idClaimType = 1;
    } else if (this.componentData?.issueType == 'Guaranteed Ride Home') {
      this.idClaimType = 2;
    } else {
      this.idClaimType = this.componentData?.idClaimType;
    }
    if (this.componentData) {
      this.idMemberSmartCardOrca = this.componentData[0]?.idMemberSmartCard;
      this.accountNumber = this.componentData[0]?.accountNumber?.slice(-4);
    }
    if (this.shoppingCartService.getMBBShoppingCartDetails) {
      this.mbbShoppingCartDetails = this.shoppingCartService.getMBBShoppingCartDetails;
    }
  }

  onClickAction(name: string): void {
    switch (name) {
      case 'claims':
        this.deleteClaims();
        break;
      case 'viewclaims':
        this.deleteClaims();
        break;
      case 'submitclaims':
        this.modalRef.close(true);
        break;
      case 'orderDetailsModal':
        this.modalRef.close(true);
        break;
      case 'reviewOrderDelete':
        this.modalRef.close(true);
        break;
      case 'cancelOrcaCard':
        this.cancelOrcaCardRequest();
        break;
      case 'enableFerry':
        this.enableOrcaForFerry();
        break;
      case 'creditcardDelete':
        this.modalRef.close(true);
        break;
      case 'memberACHDelete':
        this.modalRef.close(true);
        break;
      case 'UnEnrollAboutMyCard':
        this.unEnrollUserFromLSA();
        break;
    }
  }
  closePopup(): void {
    this.modalRef.close();
  }
  deletecreditcard() { }
  deleteClaims() {
    this.notificationService.targetElement = this.errorContainer;

    if (this.componentData.isRecurring === true && (this.componentData.idClaim === 0 || this.componentData.idClaim === '' || this.componentData.idClaim === '0') && this.componentData.uiClaimStatus === UiClaimStatus.NotSubmitted) {
      const rawBenefitMonth = this.componentData.benefitMonth;
      const benefitMonthDate = rawBenefitMonth ? new Date(rawBenefitMonth) : null;
      this.deleteBikePurchaseClaimSubscription = this.claimService
        .cancelEnrolment(Number(AppUtils.memberId), this.componentData.idCrmrecurringClaim, {}, benefitMonthDate)
        .subscribe((response: boolean) => {
          if (response) {
            this.notificationService.displayMessage(Messages.deleteClaimSuccess, MessageType.Success);
            setTimeout(() => {
              this.modalRef.close(true);
            }, 2000);
          } else {
            this.notificationService.displayMessage(Messages.apiError, MessageType.Error);
          }
        });
    }
    else {
      this.claimService.deleteClaim(this.idClaim, this.idClaimType).subscribe((response: boolean) => {
        if (response) {
          this.notificationService.displayMessage(Messages.deleteClaimSuccess, MessageType.Success);
          setTimeout(() => {
            this.modalRef.close(true);
          }, 2000);
        } else {
          this.notificationService.displayMessage(Messages.apiError, MessageType.Error);
        }
      });
    }
  }
  cancelOrcaCardRequest() {
    this.notificationService.targetElement = this.errorContainer;
    let cancelCardObject: OrcaPassportCancelRequestDTO = {};
    cancelCardObject.idMember = Number(AppUtils.memberId);
    cancelCardObject.idMemberSmartCard = this.idMemberSmartCardOrca;
    cancelCardObject.comment = 'Cancel request for Orca Card';
    this.productSubscription = this.productService
      .cancelOrcaCardRequest(cancelCardObject)
      .subscribe((response: boolean) => {
        if (response) {
          this.notificationService.displayMessage(
            `our ORCA card ··${this.accountNumber} has been successfully canceled.`,
            MessageType.Success
          );
          setTimeout(() => {
            this.modalRef.close(true);
          }, 2000);
        } else {
          this.notificationService.displayMessage(Messages.apiError, MessageType.Error);
        }
      });
  }

  enableOrcaForFerry() {
    let ferryAccessObject: OrcaPassportFerryRequestDTO = {
      idMemberSmartCard: 0,
      idMember: 0,
      idORCAPassportFerryStatus: 0,
    };

    ferryAccessObject.idMemberSmartCard = this.idMemberSmartCardOrca;
    ferryAccessObject.idMember = Number(AppUtils.memberId);
    ferryAccessObject.idORCAPassportFerryStatus = OrcaFerryStatus.EnabledRequested;
    ferryAccessObject.comment = 'Enable Ferry Access.';

    this.productSubscription = this.productService
      .enableFerryAccessOrca(ferryAccessObject)
      .subscribe((response: boolean) => {
        if (response) {
          this.modalRefFerrySuccess = this.notificationService.openConfirmModal(
            'You Now have Ferry Access!',
            true,
            ButtonText.Close,
            ModalCssClass.LargeModal,
            `<p class='text-center font-20'>Ferry access has been successfully enabled for your card.</p>
      <p class='font-20 text-center'><span class='font-weight-700'>Your card will be ready for ferry use by [3 business days from </br> now].</span> You can submit claims in the meantime.</p>`,
            true,
            false,
            null,
            'assets/images/Success.svg'
          );

          this.modalRefFerrySuccess.onClose.subscribe(res => {
            if (res) {
              this.modalRef.close(true);
            }
          });
        }
      });
  }

  unEnrollUserFromLSA() {
    this.notificationService.targetElement = this.errorContainer;
    const deleteProducts: DeleteCartProductDTO = {};
    deleteProducts.idMember = Number(AppUtils.memberId);
    deleteProducts.idCartProduct = this.mbbShoppingCartDetails?.products[0]?.idCartProducts;
    deleteProducts.idShoppingCart = this.mbbShoppingCartDetails?.idShoppingCart;
    deleteProducts.isUnenrollMBBTR = true;
    this.shoppingCartSubscription = this.shoppingCartService
      .deleteProductDashboard(deleteProducts)
      .subscribe(response => {
        this.notificationService.displayMessage(
          'You’ve successfully been unenrolled from your lifestyle spending account.',
          MessageType.Success
        );
        setTimeout(() => {
          this.modalRef.close(true);
        }, 2000);
      });
  }

  ngOnDestroy(): void {
    if (this.productSubscription) {
      this.productSubscription.unsubscribe();
    }
    if(this.deleteBikePurchaseClaimSubscription) {
      this.deleteBikePurchaseClaimSubscription.unsubscribe();
    }
  }
}
